










import Vue from 'vue';

export default Vue.extend({
  props: {
    value: { type: [Number, String], default: undefined },
    hideOverflow: { type: Boolean, default: false },
    scroll: { type: Boolean, default: false },
  },
  computed: {
    styleList(): Record<string, any> {
      const ratioNumber = Number.parseFloat(this.value as any);
      return {
        'padding-top': `${(1 / ratioNumber) * 100}%`,
        overflow: this.overflowValue,
      };
    },
    overflowValue() {
      if (this.hideOverflow) {
        return 'hidden';
      }
      if (this.scroll) {
        return 'scroll';
      }
      return undefined;
    },
  },
});
